import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { Button, makeStyles, Toolbar, Typography } from '@material-ui/core'
import { Add, DeleteOutline, HelpRounded } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'
import MarketContext from '../containers/MarketContext'
import FundamentalMobile from '../containers/FundamentalMobile'
import BehaviouralAnalysisMobile from '../containers/BehaviouralAnalysisMobile'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { clearD3Tips, getColorFromStatus, waiting } from '../ultils/dataUtil'
import fundamental_loading from '../assets/images/Skeletons/fundamental_loading.png'
import marketContext_loading from '../assets/images/Skeletons/marketContext_loading.png'
import behavior_loading from '../assets/images/Skeletons/behavior_loading.png'
import FundamentalsCreditAnalysisMobile from '../containers/FundamentalsCreditAnalysisMobile'
import { getCookie, setCookieHelper } from '../ultils/cookie'
import { userService } from '../services/users.services'
import { EXPIRED_SECOND } from '../constants/Cookie'
import {
  getCompanyStatus,
  getCompanyStatusWithType,
} from '../ultils/chart-d3-utils'
import { Alert, TIME_SHOW_ALERT } from '../components/Alert'
import NoteContext from '../containers/NoteContext'
import NewsFeed from '../components/NewsFeed'
import ResponsiveArticle from '../components/ResponsiveArticle'
import BFTabs from '../components/Tabs/BFTabs'
import BFTab from '../components/Tabs/BFTab'
import PortfolioTodayMobile from '../containers/PortfolioTodayMobile'
import PortfolioLastWeekMobile from '../containers/PortfolioLastWeekMobile'
import PortfolioTooltipModal from '../components/PortfolioTooltipModal'
import ConfirmRemovePortfolioCompany from '../components/ConfirmRemovePortfolioCompany'

const parseBooleanFlag = (value: any) => String(value).toLowerCase() === 'true'

const useStyles = makeStyles({
  toolbar: {
    margin: '0px 20px 10px 20px',
    padding: '15px 12px 0 12px',
    minHeight: 'unset',
    background: 'white',
    boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.06)',
    border: '1px solid #DFE4EB',
  },
  backToPortfolioPage: {
    '&span': {
      marginLeft: 0,
    },
  },
  lgBanner: {
    width: '100%',
    backgroundPosition: 'inherit',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    marginBottom: 30,
  },
  searchCommonContainer: {
    marginLeft: 10,
    width: 250,
  },
  headContainer: {
    width: '100%',
  },
  headContainerActiveScroll: {
    borderBottom: 'none',
    // paddingBottom: 8,
  },
  internalToggle: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginLeft: 12,
    flex: '0 0 auto',
  },
  internalToggleLabel: {
    fontSize: 12,
    lineHeight: '18px',
    color: '#1B3963',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  switchTrack: {
    position: 'relative',
    display: 'inline-block',
    width: 28,
    height: 16,
    borderRadius: 999,
    background: '#E6EAF0',
    transition: 'background 0.2s ease',
    cursor: 'pointer',
    overflow: 'hidden',
  },
  switchTrackActive: {
    background: '#1B3963',
  },
  switchThumb: {
    position: 'absolute',
    top: 2,
    left: 2,
    right: 'auto',
    width: 12,
    height: 12,
    borderRadius: '50%',
    background: '#FFFFFF',
    transition: 'left 0.2s ease, right 0.2s ease',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
  },
  switchThumbActive: {
    left: 'auto',
    right: 2,
  },
  tabsGroup: {
    flex: '1 1 0',
    minWidth: 0,
    height: 42,
    padding: 4,
    borderRadius: 3,
    background: '#FFFFFF',
    border: 'none',
    boxSizing: 'border-box',
    minHeight: 'unset',
    '& .MuiTabs-flexContainer': {
      gap: 4,
      minWidth: 0,
    },
    '& .MuiTab-root.small': {
      minWidth: 0,
      flex: '1 1 0',
      height: 32,
      padding: '5px 2px',
      borderRadius: 3,
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      fontSize: 13,
      lineHeight: '20px',
      textTransform: 'none',
    },
    '& .MuiTab-root.small .MuiTab-wrapper': {
      width: '100%',
      padding: '0 !important',
      color: '#757575',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '@media (max-width: 360px)': {
      '& .MuiTab-root.small': {
        fontSize: 12,
        padding: '4px 2px',
      },
    },
    '& .MuiTab-root.small.Mui-selected': {
      background: '#1B3963',
      color: '#FFFFFF',
    },
    '& .MuiTab-root.small.Mui-selected .MuiTab-wrapper': {
      color: '#FFFFFF',
    },
  },
  button: {
    width: '100%',
    height: '40px',
    color: '#fff',
    backgroundColor: '#1B3963',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: 14,
    '&:hover': {
      backgroundColor: '#1B3963',
      color: '#fff',
    },
  },
  spinnerIcon: {
    width: 20,
    marginLeft: 8,
  },
  pageTitle: {
    lineHeight: '24px',
    // marginBottom: 16,
  },
  pageTitleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    width: '100%',
  },
  title: {
    padding: '20px 0px 30px 0px',
  },
  container: {
    padding: '0px 20px 0px 20px',
  },
  companyDetail: {
    background: 'white',
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    fontSize: 14,
  },
  companyDetailLine2: {
    padding: '5px 0 10px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    fontSize: 14,
  },
  quickNoteCard: {
    background: '#FFFFFF',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    boxSizing: 'border-box',
    padding: '16px 16px 12px 16px',
    marginBottom: 10,
  },
  riskStoryCard: {
    marginTop: 10,
    background: '#FFFFFF',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    boxSizing: 'border-box',
    padding: '16px 16px 12px 16px',
  },
  breadcrumb: {
    color: '#1B3963',
    '& .MuiBreadcrumbs-li': {
      fontSize: 12,
      '& p': {
        fontSize: 12,
      },
    },
  },
  status: {
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '5px',
    '& div': {
      fontSize: '12px !important',
    },
  },
  circle: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    position: 'relative',
    '& > div': {
      height: 16,
      width: 16,
      opacity: '0.35',
      borderRadius: '50%',
      position: 'absolute',
      left: '-4px',
      top: '-4px',
      margin: 0,
      'animation-name': `$backgroundColorPalette`,
      'animation-duration': '1s',
      'animation-iteration-count': 'infinite',
      'animation-direction': 'alternate',
      'animation-timing-function': 'liner',
    },
  },
  '@keyframes backgroundColorPalette': {
    '0%': {
      opacity: 0.25,
    },
    '25%': {
      opacity: 0.45,
    },
    '50%': {
      opacity: 0.55,
    },
    '75%': {
      opacity: 0.45,
    },
    '100%': {
      opacity: 0.25,
    },
  },
  exportBtn: {
    display: 'flex',
    alignItems: 'center',
    color: '#1B3963',
    padding: '7px 10px',
    background: '#fff',
    border: '1px solid #DFE4EB',
    borderRadius: 3,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    '& img': {
      marginRight: 7,
      width: 14,
      color: '#474747',
    },
  },
  exportBar: {
    padding: '17px 24px 17px 24px',
    display: ' flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headSectionList: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
  },
  jumpItem: {
    fontSize: '10px',
    lineHeight: '22px',
    fontWeight: 400,
    color: 'black',
  },
  activeLink: {
    '& div': {
      color: '#3393F3',
    },
  },
  scrollHead: {
    position: 'sticky',
    top: 0,
    background: '#F5F8FF',
    zIndex: 2,
  },
  activeScrollHead: {
    background: '#FFFFFF',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
  },
  spinnerContainer: {
    width: '100%',
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toolbarActiveScroll: {
    position: 'sticky',
    top: 0,
    background: 'white',
    zIndex: 9,
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
    paddingTop: 8,
    paddingBottom: 8,
  },
  jumpItemActive: {
    color: '#3393F3',
  },
  companyName: {
    flex: '1 1 auto',
    minWidth: 0,
    fontSize: 18,
    lineHeight: '26px',
    fontWeight: 400,
    color: '#181818',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
  headSectionListContainer: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    fontSize: '12px',
    marginLeft: -10,
  },
  companyDetailSub1: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 400,
    color: 'rgb(71, 71, 71, 0.6)',
  },
  companyDetailSub2: {
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 600,
    color: '#1B3963',
  },
  stickyBottomTabMobile: {
    position: 'fixed',
    width: '100%',
    height: '70px',
    bottom: 0,
    left: 0,
    zIndex: 10,
    background: 'white',
    boxShadow: '0px -5px 10px rgba(0, 0, 0, 0.06), 0px -1px 0px #EBEFF4',
    boxSizing: 'border-box',
    padding: '15px 20px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  infoColumn: {
    padding: '0px 3px',
  },
  portfolioTable: {
    backgroundColor: '#fff',
    padding: '20px 25px',
    border: '1px solid #DFE4EB',
    marginTop: '40px',
    borderRadius: 5,
    marginBottom: 35,
  },
  pMobileControlCombo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  portfolioListContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#1B3963',
    padding: '0 12px',
    height: 40,
    borderRadius: 3,
    cursor: 'pointer',
    flex: '0 0 auto',
  },
  FormatListBulletedIcon: {
    color: 'white',
    width: 22,
  },
  portfolioListTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    color: '#FFFFFF',
    marginLeft: 8,
  },
  pMPortfolioTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '28px',
    color: '#181818',
  },
  toolTip: {
    color: '#8D9CB1',
    width: 20,
    height: 20,
    fontSize: 20,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 5,
  },
  subTitle: {
    marginBottom: 15,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    color: '#5E5E5E',
  },
})

const CompanyPageMobile = () => {
  const classes = useStyles()
  const {
    state,
    cleanUp,
    addTickers,
    getPrices,
    getEvents,
    getTickersOnlyInPortfolio,
    getAllTickersInUniverse,
    getScanCharts,
    getBehaviourAnalysisChartData,
    getCreditSeries,
    getNotes,
    changeSelectedTab,
    changeSelectedRiskTab,
  } = useContext(PortfolioContext)
  const [companyInfo, setCompanyInfo] = useState<any>({})
  const [isStartScrolling, setIsStartScrolling] = useState(false)
  const [isInternalUser, setIsInternalUser] = useState(
    parseBooleanFlag(getCookie('analysis_flag')),
  )
  const [showInternalPanels, setShowInternalPanels] = useState(false)
  const [color, setColor] = useState('')
  const companyDetailRef = useRef<HTMLDivElement>(null)
  const hasAutoScrolledRef = useRef<string | null>(null)
  const advancedPanelsFetchedRef = useRef<string | null>(null)
  const [recent, setRecent] = useState<any>([])
  const [flagGetCompanyData, setFlagGetCompanyData] = useState<boolean>(false)
  const [selectedTab, setSelectedTab] = useState(state.selectedTab)
  const [selectedRiskTypeTab, setSelectedRiskTypeTab] = useState(
    state.selectedRiskTypeTab,
  )
  const [openTooltip, setOpenTooltip] = React.useState(false)
  const [openConfirmRemoveDialog, setOpenConfirmRemoveDialog] = useState(false)
  const [removeData, setRemoveData] = useState<any>(null)
  const firstNotesData = React.useMemo(() => {
    const notesData = state?.notesData
    if (Array.isArray(notesData)) return notesData[0]
    if (Array.isArray(notesData?.history)) return notesData.history[0]
    if (Array.isArray(notesData?.notes_history))
      return notesData.notes_history[0]
    if (Array.isArray(notesData?.note_history)) return notesData.note_history[0]
    if (Array.isArray(notesData?.signal_history))
      return notesData.signal_history[0]
    if (Array.isArray(notesData?.signals)) return notesData.signals[0]
    if (Array.isArray(notesData?.data)) return notesData.data[0]
    return notesData
  }, [state?.notesData])
  const hasNotesData =
    !state.notesDataLoading && !!firstNotesData?.signal_overview
  const showNotesContext =
    hasNotesData && companyInfo?.risk_outlook !== 'Neutral'

  const latestRiskStoryData = React.useMemo(() => {
    const events = state?.marketContext?.eventData ?? []
    const riskStories = events.filter(
      (item: any) => item.signal_type === 'Risk Story',
    )
    if (!riskStories.length) {
      return []
    }
    return [...riskStories]
      .sort(
        (a: any, b: any) =>
          new Date(b.date).getTime() - new Date(a.date).getTime(),
      )
      .slice(0, 2)
  }, [state?.marketContext?.eventData])

  const history = useHistory()

  const changeRiskTypeTabView = (
    event: React.ChangeEvent<{}>,
    newValue?: any,
  ) => {
    setSelectedRiskTypeTab(newValue)
    changeSelectedRiskTab(newValue)
  }

  const handleClickOpenTooltip = () => {
    setOpenTooltip(true)
  }

  const toggleInternalPanels = () => {
    setShowInternalPanels(prev => !prev)
  }

  const handleInternalToggleKeyDown = (
    event: React.KeyboardEvent<HTMLDivElement>,
  ) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      toggleInternalPanels()
    }
  }

  const setInternalFromResponse = (response: any) => {
    const analysisFlagValue =
      response?.analysis_flag ?? response?.data?.analysis_flag
    if (analysisFlagValue === undefined || analysisFlagValue === null) return
    setCookieHelper('analysis_flag', analysisFlagValue, EXPIRED_SECOND)
    setIsInternalUser(parseBooleanFlag(analysisFlagValue))
  }

  const baseFromDate = '2017-01-03'
  const fromDateForPriceAndCredit = '2020-01-01'
  const baseToDate = '2030-01-01'

  const changeTabView = (event: React.ChangeEvent<{}>, newValue?: any) => {
    setSelectedTab(newValue)
    changeSelectedTab(newValue)
  }

  const onHandleScroll = (evt: any) => {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop
    setIsStartScrolling(scrollPosition !== 0)
  }

  useEffect(() => {
    window.addEventListener('scroll', onHandleScroll)
    return () => window.removeEventListener('scroll', onHandleScroll)
  }, [])

  const tickerId = window.location.pathname.split('/')[2]
    ? window.location.pathname.split('/')[2]
    : 'RVA.AU'

  useEffect(() => {
    setShowInternalPanels(false)
    advancedPanelsFetchedRef.current = null
  }, [tickerId])

  useEffect(() => {
    if (!isInternalUser) {
      setShowInternalPanels(false)
    }
  }, [isInternalUser])

  const companyExistedInPortfolio = React.useMemo(
    () => state.tickersInPortfolio.map((i: any) => i.ticker).includes(tickerId),
    [state.tickersInPortfolio, tickerId],
  )

  useEffect(() => {
    clearD3Tips()
  }, [])

  const addToPortfolio = () => {
    const userId = getCookie('userId')
    addTickers(userId, tickerId)
  }

  const deleteFromPortfolio = () => {
    setOpenConfirmRemoveDialog(true)
    setRemoveData(tickerId)
  }

  const getAllTickersInUniverses = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInUniverse ||
        (Array.isArray(state?.tickersInUniverse) &&
          state?.tickersInUniverse.length === 0)
      ) {
        getAllTickersInUniverse(userId)
      }
    },
    [state?.tickersInUniverse],
  )

  const getTickersOnlyInPortfolios = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInPortfolio ||
        (Array.isArray(state?.tickersInPortfolio) &&
          state?.tickersInPortfolio.length === 0)
      ) {
        getTickersOnlyInPortfolio(userId)
      }
    },
    [state?.tickersInPortfolio],
  )

  const getCompanyData = async (
    tickerId: string,
    fromDate: string,
    toDate: string,
    userId: string,
    fromDateForPriceAndCredit: string | null = null,
  ) => {
    getTickersOnlyInPortfolios(userId)
    getNotes(tickerId, userId)
    getPrices(tickerId, fromDateForPriceAndCredit ?? fromDate, toDate, userId)
    getEvents(tickerId, userId)
  }

  const getAdvancedCompanyData = async (
    tickerId: string,
    fromDate: string,
    toDate: string,
    userId: string,
    fromDateForPriceAndCredit: string | null = null,
  ) => {
    getScanCharts(tickerId, userId)
    getBehaviourAnalysisChartData(userId, tickerId, fromDate, toDate)
    getCreditSeries(
      userId,
      tickerId,
      fromDateForPriceAndCredit ?? fromDate,
      toDate,
    )
  }

  const maybeFetchAdvancedCompanyData = (
    userId: string,
    internalFlag: boolean,
  ) => {
    if (!internalFlag) return
    if (advancedPanelsFetchedRef.current === tickerId) return
    advancedPanelsFetchedRef.current = tickerId
    getAdvancedCompanyData(
      tickerId,
      baseFromDate,
      baseToDate,
      userId,
      fromDateForPriceAndCredit,
    )
  }

  useEffect(() => {
    if (!companyDetailRef.current) return
    const y =
      companyDetailRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      70
    window.scrollTo({ top: y, behavior: 'smooth' })
    const fetchingMarketContextData = async () => {
      await cleanUp()
      if (!getCookie('userId') && getCookie('accessToken')) {
        userService
          .getUser(getCookie('email'))
          .then(async res => {
            setCookieHelper('userId', res.data, EXPIRED_SECOND)
            const internalFlag = parseBooleanFlag(
              res?.analysis_flag ?? res?.data?.analysis_flag,
            )
            setInternalFromResponse(res)
            const userId = res.data
            getAllTickersInUniverses(userId)
            getCompanyData(
              tickerId,
              baseFromDate,
              baseToDate,
              userId,
              fromDateForPriceAndCredit,
            )
            maybeFetchAdvancedCompanyData(userId, internalFlag)
          })
          .catch(() => {})
      } else {
        const userId = getCookie('userId')
        getAllTickersInUniverses(userId)
        getCompanyData(
          tickerId,
          baseFromDate,
          baseToDate,
          userId,
          fromDateForPriceAndCredit,
        )
        maybeFetchAdvancedCompanyData(
          userId,
          parseBooleanFlag(getCookie('analysis_flag')),
        )
        if (!getCookie('analysis_flag') && getCookie('accessToken')) {
          userService
            .getUser(getCookie('email'))
            .then(res => {
              const internalFlag = parseBooleanFlag(
                res?.analysis_flag ?? res?.data?.analysis_flag,
              )
              setInternalFromResponse(res)
              maybeFetchAdvancedCompanyData(res.data, internalFlag)
            })
            .catch(() => {})
        }
      }
    }
    fetchingMarketContextData()
  }, [tickerId])

  useEffect(() => {
    if (state.loading) return
    if (!companyDetailRef.current) return
    if (!companyInfo?.ticker) return
    if (hasAutoScrolledRef.current === companyInfo.ticker) return

    const y =
      companyDetailRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      60
    window.scrollTo({ top: y, behavior: 'smooth' })
    hasAutoScrolledRef.current = companyInfo.ticker
  }, [state.loading, companyInfo?.ticker])

  useEffect(() => {
    if (state.tickersInUniverse.length > 0) {
      let data = state.tickersInUniverse.filter(
        (item: any) => item.ticker === tickerId,
      )[0]
      if (data) {
        setFlagGetCompanyData(true)
        setCompanyInfo(data)
        setColor(getColorFromStatus(data.risk_outlook))
      } else {
        const showContentNotFound = async () => {
          Alert.info(
            'This company is currently not available in our coverage. Navigating back to the portfolio page',
          )
          await waiting(TIME_SHOW_ALERT)
          history.push('/portfolio')
        }
        showContentNotFound()
      }
    }
  }, [state.tickersInUniverse, tickerId])

  const showImpliedRating = getCookie('implied_rating_flag') !== 'False'
  const canShowAdvancedPanels = isInternalUser && showInternalPanels

  return (
    <div>
      <div id="companyPage">
        {state.loading && (
          <div className={classes.portfolioTable}>
            <ResponsiveArticle />
          </div>
        )}
        <div style={{ margin: '20px 20px 10px 20px' }}>
          <div className={classes.pMobileControlCombo}>
            <BFTabs
              size="small"
              value={selectedTab}
              onChange={changeTabView}
              className={classes.tabsGroup}
            >
              <BFTab size="small" label="Today" value={0} />
              <BFTab size="small" label="Week to Date" value={1} />
            </BFTabs>
          </div>
          {!state.loading && (
            <>
              {selectedTab === 0 ? (
                <>
                  <div className={classes.pMPortfolioTitle}>
                    Portfolio
                    <HelpRounded
                      className={classes.toolTip}
                      key="1"
                      onClick={() => handleClickOpenTooltip()}
                    />
                  </div>
                  <div className={classes.subTitle}>
                    (Heat-Map of Risk in your Portfolio Companies)
                  </div>
                  <PortfolioTodayMobile
                    tickers={state.tickersInPortfolio}
                    riskType={selectedRiskTypeTab}
                  />
                </>
              ) : (
                <PortfolioLastWeekMobile
                  tickers={state.tickersInPortfolio}
                  riskType={selectedRiskTypeTab}
                />
              )}
            </>
          )}
        </div>
        <Toolbar ref={companyDetailRef} className={`${classes.toolbar}`}>
          <div className={`${classes.headContainer}`}>
            <Typography component="div" className={classes.pageTitle}>
              <div className={classes.pageTitleRow}>
                <div className={classes.companyName}>
                  {companyInfo?.proper_name}
                </div>
                {isInternalUser && (
                  <div className={classes.internalToggle}>
                    {/* <span className={classes.internalToggleLabel}>
                  Show analysis
                </span> */}
                    <div
                      className={`${classes.switchTrack} ${
                        showInternalPanels ? classes.switchTrackActive : ''
                      }`}
                      role="switch"
                      aria-checked={showInternalPanels}
                      aria-label="Show analysis panels"
                      tabIndex={0}
                      onClick={toggleInternalPanels}
                      onKeyDown={handleInternalToggleKeyDown}
                    >
                      <div
                        className={`${classes.switchThumb} ${
                          showInternalPanels ? classes.switchThumbActive : ''
                        }`}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className={classes.status}>
                <div
                  className={classes.circle}
                  style={{ backgroundColor: color }}
                >
                  <div style={{ backgroundColor: color }} />
                </div>
                <div style={{ color, marginLeft: '8px' }}>
                  {getCompanyStatus(companyInfo?.risk_outlook)}
                </div>
              </div>
            </Typography>
            <div className={classes.companyDetail}>
              {showImpliedRating && (
                <div className={classes.infoColumn}>
                  <div className={classes.companyDetailSub1}>
                    Implied rating
                  </div>
                  <div className={classes.companyDetailSub2}>
                    {companyInfo.bfaiRating ? companyInfo?.bfaiRating : 'N/A'}
                  </div>
                </div>
              )}
              <div className={classes.infoColumn}>
                <div className={classes.companyDetailSub1}>Ticker</div>
                <div className={classes.companyDetailSub2}>
                  {companyInfo?.ticker}
                </div>
              </div>
              <div className={classes.infoColumn}>
                <div className={classes.companyDetailSub1}>Country</div>
                <div className={classes.companyDetailSub2}>
                  {companyInfo?.iso_country}
                </div>
              </div>
              <div className={classes.infoColumn}>
                <div className={classes.companyDetailSub1}>Sector</div>
                <div className={classes.companyDetailSub2}>
                  {companyInfo?.factset_sector_desc}
                </div>
              </div>
            </div>
            <div className={classes.companyDetailLine2}>
              {!!companyInfo?.risk_outlook_date &&
                companyInfo?.risk_outlook !== 'Neutral' && (
                  <div className={classes.infoColumn}>
                    <div className={classes.companyDetailSub1}>
                      Date on Watchlist
                    </div>
                    <div className={classes.companyDetailSub2}>
                      {companyInfo.risk_outlook_date}
                    </div>
                  </div>
                )}
              {!!companyInfo?.returns && companyInfo?.returns !== 'null' && (
                <div className={classes.infoColumn}>
                  <div className={classes.companyDetailSub1}>
                    Equity price since Watchlist
                  </div>
                  <div
                    className={classes.companyDetailSub2}
                    style={{
                      color: `${
                        parseFloat(companyInfo?.returns) > 0 ? 'green' : 'red'
                      }`,
                    }}
                  >
                    {companyInfo.returns}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Toolbar>

        <div className={classes.container}>
          {state.marketContext.eventLoading ||
          state.marketContext.priceLoading ? (
            <div
              className={classes.lgBanner}
              style={{
                backgroundImage: `url(${marketContext_loading})`,
                height: 625,
              }}
            />
          ) : (
            <div id="risk">
              <MarketContext
                tickerId={tickerId}
                animateInitialDraw
                riskStatus={{
                  color: getColorFromStatus(companyInfo?.risk_outlook),
                  text: getCompanyStatusWithType(
                    companyInfo?.risk_outlook,
                    'Equity',
                  ),
                }}
              />
            </div>
          )}

          {showNotesContext && (
            <div id="notes">
              <NoteContext tickerId={tickerId} textFontSize={undefined} />
            </div>
          )}

          {showNotesContext && (
            <div className={classes.riskStoryCard}>
              <NewsFeed
                latestRiskStoryData={latestRiskStoryData}
                title="Risk Story"
                subTitle="Continual Updated Company Risk"
                showContentBorder={false}
                splitColumns={false}
              />
            </div>
          )}

          {canShowAdvancedPanels && (
            <>
              {state.behaviorChartLoading ? (
                <div
                  className={classes.lgBanner}
                  style={{
                    backgroundImage: `url(${behavior_loading})`,
                    height: 400,
                  }}
                />
              ) : (
                state.showBehavioural && (
                  <div id="behavioural" style={{ marginTop: 10 }}>
                    <BehaviouralAnalysisMobile tickerId={tickerId} />
                  </div>
                )
              )}

              {state.fundamentalLoading ? (
                <div
                  className={classes.lgBanner}
                  style={{
                    backgroundImage: `url(${fundamental_loading})`,
                    height: 840,
                  }}
                />
              ) : (
                state.showFundamentals && (
                  <div id="fundamental">
                    <FundamentalMobile tickerId={tickerId} />
                  </div>
                )
              )}

              {!state.creditLoading &&
                !state?.marketContext?.priceLoading &&
                !state?.marketContext?.eventLoading &&
                state.showCreditChart && (
                  <div id="fundamentalCreditAnalysis">
                    <FundamentalsCreditAnalysisMobile
                      companyInfo={companyInfo}
                      riskStatus={{
                        color: getColorFromStatus(companyInfo?.credit_status),
                        text: getCompanyStatusWithType(
                          companyInfo?.credit_status,
                          'Credit',
                        ),
                      }}
                    />
                  </div>
                )}
            </>
          )}
        </div>

        {!companyExistedInPortfolio && (
          <div className={classes.stickyBottomTabMobile}>
            <Button
              onClick={addToPortfolio}
              startIcon={<Add />}
              className={classes.button}
              variant="outlined"
              color="primary"
              fullWidth
            >
              Add to portfolio
            </Button>
          </div>
        )}

        {companyExistedInPortfolio && (
          <div className={classes.stickyBottomTabMobile}>
            <Button
              onClick={deleteFromPortfolio}
              startIcon={<DeleteOutline />}
              className={classes.button}
              variant="outlined"
              color="primary"
            >
              Delete from Portfolio
            </Button>
          </div>
        )}

        <PortfolioTooltipModal
          open={openTooltip}
          handleClose={() => {
            setOpenTooltip(false)
          }}
        />

        <ConfirmRemovePortfolioCompany
          open={openConfirmRemoveDialog}
          setOpen={setOpenConfirmRemoveDialog}
          removeData={removeData}
          setRemoveData={setRemoveData}
        />
      </div>
    </div>
  )
}

export default CompanyPageMobile
